// const WEB_SITE = 'http://xiantest.3todo.com' // 测试服
// const WEB_SITE = 'http://xianxinli.3todo.com' // 正式服
// const WEB_SITE = 'https://www.psyxa.com' // 正式服
const WEB_NAME = '喜安人文心理'
const qnDomail = 'http://xaqn.3todo.com/'
let protocol = document.location.protocol === 'https:' ? 'https://' : 'http://' //获取当前网站协议是http还是https
const WEB_SITE = window.location.hostname == 'localhost' ? 'http://r.psyxa.com' : protocol + window.location.hostname
// const WEBSOCKETIP = '127.0.0.1:8282'
// const WEBSOCKETIP = '139.224.36.9:1008'
// const WEBSOCKETIP = window.location.hostname == 'localhost' ? '127.0.0.1:8282' : 'www.psyxa.com:1009'
const hostname = window.location.hostname
let WEBSOCKETIP = 'ws://127.0.0.1:8282'
if (hostname === 'www.psyxa.com'){
    WEBSOCKETIP = 'wss://www.psyxa.com:1009'
}else if (hostname === 'revt.psyxa.com'){
    WEBSOCKETIP = 'ws://127.0.0.1:8282'
}

export default {
    WEB_SITE,
    WEB_NAME,
    qnDomail,
    WEBSOCKETIP
}
